import Mochiaruki from '../assets/scene/scene_mochiaruki.jpg';
import Noukotsu from '../assets/scene/scene_noukotsu.jpg';
import Ouchi from '../assets/scene/scene_ouchi.jpg';
import Photo from '../assets/scene/scene_photo.jpg';
import Season from '../assets/scene/scene_season.jpg';
import Sougi from '../assets/scene/scene_sougi.jpg';

export const SCENES = [
  {
    handle: 'お家でペット供養',
    description:
      'いつも一緒にいたリビングやお部屋にぴったりのメモリアルグッズ。\nインテリアになじむ仏壇等、これからもずっと一緒の時間を過ごしていただけるアイテムです。',
    imageUrl: Ouchi,
  },
  {
    handle: 'いつでも一緒に持ち歩き',
    description:
      '片時も離れたくないという飼い主さんのために、ネックレスやキーホルダータイプの遺骨カプセルをご用意しました。\nチャームを付けてアレンジするのもおすすめです。',
    imageUrl: Mochiaruki,
  },
  {
    handle: 'ペットの葬儀で',
    description:
      'バスケット棺やお布団等、ペットちゃんのご葬儀にご利用いただける商品です。\nバスケット棺には、お花や大好きだったおやつを入れてあげてください。最愛のペットちゃんの旅立ちにぴったりの商品です。',
    imageUrl: Sougi,
  },
  {
    handle: '納骨堂に納めるグッズ',
    description:
      '骨壺、お位牌、お供えフラワー等、納骨堂にお納めするのにおすすめの商品です。\n※ 各納骨堂により、お納め可能な物が変わりますので、必ず事前にご確認の上ご購入ください。',
    imageUrl: Noukotsu,
  },
  {
    handle: '写真・名入れでオーダーメイド',
    description:
      '生前の姿をずっと残しておける、ペットちゃんの写真プリントや名入れができるオーダーメイドのメモリアルグッズを集めました。\n写真が入るお位牌や写真から作るクッション、骨壺カバーなど、様々なデザインでご用意しております。',
    imageUrl: Photo,
  },
  {
    handle: '季節毎のご供養',
    description:
      'お盆やお彼岸等、季節毎のご供養にぴったりの商品です。\n盆棚にお供え物と一緒にお飾りする精霊馬（しょうりょううま）やきゅうり・ナスのお飾り、ちょうちんや灯籠等でペットちゃんをお迎えください。',
    imageUrl: Season,
  },
];

export const scenes = SCENES.map((scene) => scene.handle);

export const getSceneImage = (handle: string) =>
  SCENES.find((scene) => scene.handle === handle)?.imageUrl ?? '';

export const getSceneDescription = (handle: string) =>
  SCENES.find((scene) => scene.handle === handle)?.description ?? '';
